<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2244_54155)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.7 11C4.7 14.4794 7.52061 17.3 11 17.3C14.4794 17.3 17.3 14.4794 17.3 11C17.3 7.52061 14.4794 4.7 11 4.7C7.52061 4.7 4.7 7.52061 4.7 11ZM11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2244_54155">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
